<template>
  <Grid gtc="200px 1fr" class="overflow-hidden relative-position">
    <template v-if="quickViewItems">
      <ModalSidebar ref="modalSidebar" :items="quickViewItems" @item-selected="openQuickView" />

      <Grid gtr="1fr auto" class="overflow-hidden">
        <ModalBody>
          <div v-if="quickView" :key="quickView.id" class="q-pa-lg bg-white-1 shadow3 border-radius-sm">
            <div class="text-heading-1 text-subtitle2 q-mb-lg">{{ quickView.name }}</div>

            <CustomFormRenderer :form="quickView.custom_form" @input="quickView.custom_form = $event">
              <template #header-actions>
                <RBtn type="link" :to="`/forms/${quickView.custom_form.form_id}`" class="q-mb-lg">edit</RBtn>
              </template>

              <template #no-form>
                <Grid
                  justify-content="center"
                  align-items="center"
                  align-content="center"
                  justify-items="center"
                  class="full-height"
                >
                  <NoData />
                  <span>There are no forms created yet</span>
                  <RBtn type="link" :to="{ name: 'forms' }">Create custom form</RBtn>
                </Grid>
              </template>
            </CustomFormRenderer>
          </div>
        </ModalBody>

        <ModalFooter>
          <RBtn size="big" type="ghost" @click="dismiss">Dismiss</RBtn>
          <RBtn size="big" type="primary" :disable="quickView && !quickView.custom_form" @click="save">Save</RBtn>
          <RBtn size="big" type="tertiary" :disable="quickView && !quickView.custom_form" @click="finalize"
            >Finalize</RBtn
          >
        </ModalFooter>
      </Grid>
    </template>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import {
  checkQuickView,
  getCount,
  getTaskData,
  openQuickView,
  setSubtitle
} from '@/reusable/workflow/task-modals/modals-shared'
// Components
import ModalSidebar from '../components/ModalSidebar'
import ModalBody from '../components/ModalBody'
import ModalFooter from '../components/ModalFooter'
import CustomFormRenderer from '@components/lm-blocks/CustomFormRenderer'
import NoData from '@/reusable/svg-icons/NoData'

export default {
  components: {
    ModalSidebar,
    ModalBody,
    ModalFooter,
    CustomFormRenderer,
    NoData
  },

  props: {
    periodId: [Number, String]
  },

  data: () => ({
    quickViewItems: null,
    quickView: null
  }),

  watch: {
    quickViewItems: 'setSubtitle'
  },

  created() {
    this.getTaskData('implementations').then(({ data }) => (this.quickViewItems = data.result))
  },

  methods: {
    getTaskData,
    getCount,
    checkQuickView,
    setSubtitle: setSubtitle('Subscriptions'),
    openQuickView: openQuickView('implementations'),

    getPayload(finalize) {
      return {
        content: this.quickView.custom_form?.content || null,
        form_id: this.quickView.custom_form?.form_id || null,
        finalized: finalize
      }
    },

    dismiss() {
      this.$emit('set-loader', true)

      apiTo
        .DISMISS_TASK('implementations', this.quickView.id)
        .then(this.checkQuickView)
        .catch(() => this.$emit('set-loader', false))
    },

    save() {
      const payload = this.getPayload(false)

      this.$emit('set-loader', true)
      apiTo.PROCESS_TASK('implementations', this.quickView.id, payload).finally(() => this.$emit('set-loader', false))
    },

    finalize() {
      const payload = this.getPayload(true)

      this.$emit('set-loader', true)
      apiTo
        .PROCESS_TASK('implementations', this.quickView.id, payload)
        .then(this.checkQuickView)
        .finally(() => this.$emit('set-loader', false))
    }
  }
}
</script>
